/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_highprotein = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-protein 40/40/20`)
};

const es_macro_highprotein = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alto en proteína 40/40/20`)
};

const de_macro_highprotein = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteinreich 40/40/20`)
};

const nl_macro_highprotein = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eiwitrijk 40/40/20`)
};

const fr_macro_highprotein = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riche en protéines 40/40/20`)
};

const it_macro_highprotein = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricca di proteine 40/40/20`)
};

const pt_br2_macro_highprotein = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiperproteica 40/40/20`)
};

const pt_macro_highprotein = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rica em proteína 40/40/20`)
};

const ja_macro_highprotein = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高タンパク 40/40/20`)
};

const zh_macro_highprotein = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高蛋白型 40/40/20`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_highprotein = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_highprotein(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_highprotein", locale)
	if (locale === "en") return en_macro_highprotein(inputs)
	if (locale === "es") return es_macro_highprotein(inputs)
	if (locale === "de") return de_macro_highprotein(inputs)
	if (locale === "nl") return nl_macro_highprotein(inputs)
	if (locale === "fr") return fr_macro_highprotein(inputs)
	if (locale === "it") return it_macro_highprotein(inputs)
	if (locale === "pt-BR") return pt_br2_macro_highprotein(inputs)
	if (locale === "pt") return pt_macro_highprotein(inputs)
	if (locale === "ja") return ja_macro_highprotein(inputs)
	return zh_macro_highprotein(inputs)
};